export enum OENDialogType {
  ORDER_ENTRY_CLOSE,
  ORDER_ENTRY_CLOSE_EXT_ORDER,
  ORDER_ENTRY_FORCE_EXT_ORDER,
  MODIFICATION_ABORT,
  MODIFICATION_CLOSE,
  MODIFICATION_CLOSE_EXT_ORDER,
  AMEND_MARKUP_ABORT,
  ORDER_ENTRY_ABORT_NOT_ALLOWED,
}
